import React, { type JSX } from "react";
import { SupNumberInput, SupFieldControl } from "@repo/core-ui";

import { FieldProps } from "../types";
import { useField } from "../hooks";

export interface NumberFieldProps extends FieldProps {
  suffixIcon?: JSX.Element;
  prefixIcon?: JSX.Element;
  step?: number;
  min?: number;
  max?: number;
}

export function SupNumberField({
  name,
  id = name,
  required,
  label,
  hint,
  hintAlign,
  prepend,
  className,
  controlClassName,
  fluid,
  disabled,
  autoFocus,
  color,
  defaultValue,
  placeholder,
  suffixIcon,
  prefixIcon,
  step,
  min,
  max,
  shouldUnregister,
  icon,
}: NumberFieldProps) {
  const { ref, value = "", error, invalid, onChange, onBlur } = useField({ name, defaultValue, autoFocus, shouldUnregister });
  const fieldColor = invalid ? "error" : color;

  return (
    <SupFieldControl
      disabled={disabled}
      fluid={fluid}
      required={required}
      id={id}
      label={label}
      hint={invalid ? error : hint}
      hintAlign={hintAlign}
      prepend={prepend}
      className={controlClassName}
      color={fieldColor}
      icon={icon}
    >
      <SupNumberInput
        ref={ref}
        id={id}
        suffixIcon={suffixIcon}
        prefixIcon={prefixIcon}
        name={name}
        className={className}
        fluid={fluid}
        color={fieldColor}
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        step={step}
        min={min}
        max={max}
        onChange={onChange}
        onBlur={onBlur}
      />
    </SupFieldControl>
  );
}
